//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as moment from "moment";

// custom pages
import Context from "context/context";
import mpc from "apis/mpc/mpc";
import { mpcStyles } from "./styles";
import useDebounce from "helpers/useDebounce";
import Loader from "components/Loader/Loader";
import { exportHeaders, exportHeaders_ca } from "./export";
import searchIcon from "assets/img/Search_Icon.png";
import audit from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Table from "components/Table/Table";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import FilterListIcon from "@material-ui/icons/FilterList";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";
import { useTranslation } from 'react-i18next';

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: 20,
      marginTop: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
  },
})(() => null);

export default function Locations(props) {
  const { state, dispatch } = useContext(Context);
  const { getMpc, search, getSalesCategory, getOrg, mpcFilter, mpcExport } =
    mpc();
  const { getAudit } = audit();

  const classes = mpcStyles();

  const [mpcData, setMpcData] = useState([]);
  const [salesCategory, setSalesCategory] = useState([]);
  const [org, setOrg] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [selectedSales, setSelectedSales] = useState({});
  const [exportData, setExportData] = useState([]);
  const [response, setResponse] = useState({
    filter: false,
  });
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation()
  const [states, setstates] = useState({
    filter: false,
    salesCategory: "",
    redemptionFrom: null,
    redemptionTo: null,
    orgName: "",
    isActive: "",
    allowPoints: "",
    allowTier: "",
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const history = useHistory();
  const location = useLocation();

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "MPC CONFIGURATIONS"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      states.filter
        ? handleFilter()
        : searchValue.length > 0
          ? handleSearch()
          : handleGetMpc();
    }
  }, [state.userInfo, offset]);

  // mpc api func
  const handleGetMpc = async () => {
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getMpc(values);
      if (res) {
        setMpcData(res.data);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  useEffect(() => {
    handleGetSalesCategoryAndOrg();
  }, []);

  // sales category and org api func
  const handleGetSalesCategoryAndOrg = async () => {
    try {
      let sales = await getSalesCategory();
      let org = await getOrg();
      if (sales) {
        setSalesCategory(sales.data);
      }
      if (org) {
        setOrg(org.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // handling search api
  useEffect(() => {
    let offsetValue = location?.state?.offset;
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else if (offsetValue) {
      setOffset(offsetValue);
      location.state = undefined;
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // search api func
  const handleSearch = async () => {
    setStates({
      salesCategory: "",
      redemptionFrom: null,
      redemptionTo: null,
      orgName: "",
      filter: false,
      isActive: "",
    });
    setResponse({ ...response, filter: false });
    setFilterCard(false);
    setSelectedOrg({});
    setSelectedSales({});
    try {
      let values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        setMpcData(res.data);
        setCount(res.count);
        return;
      }
      setMpcData([]);
    } catch (e) {
      dispatch({ type: "SET_LOADING", payload: false });
      console.log({ e });
    }
  };

  // filter api func
  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (states.salesCategory) {
        values = { ...values, salesCategory: states.salesCategory };
      }
      if (states.redemptionFrom && states.redemptionTo) {
        values = {
          ...values,
          redemptionFrom: states.redemptionFrom,
          redemptionTo: states.redemptionTo,
        };
      }
      if (states.orgName) {
        values = { ...values, orgName: states.orgName };
      }
      if (typeof states.isActive === "boolean") {
        values = { ...values, isActive: states.isActive };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await mpcFilter(values);
      if (res) {
        setMpcData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // export api function
  const handleExport = async () => {
    let values = {};
    if (searchValue) {
      values = { ...values, searchValue };
    }
    if (states.salesCategory) {
      values = { ...values, salesCategory: states.salesCategory };
    }
    if (states.redemptionFrom && states.redemptionTo) {
      values = {
        ...values,
        redemptionFrom: parseInt(states.redemptionFrom),
        redemptionTo: parseInt(states.redemptionTo),
      };
    }
    if (states.orgName) {
      values = { ...values, orgName: states.orgName };
    }
    if (typeof states.isActive === "boolean") {
      values = { ...values, isActive: states.isActive };
    }
    dispatch({ type: "SET_LOADING", payload: true });
    setIsLoading(true);
    let res = await mpcExport(values);
    if (res && res.data) {
      if(state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada'){
        setExportData(res.data.map(obj => {
          return {
            ...obj,
            product_primary_class_id: obj?.product_primary_class_id + String.fromCharCode(8203),
            primary_major_class_code: obj?.primary_major_class_code + String.fromCharCode(8203),
            primary_submajor_class_code: obj?.primary_submajor_class_code + String.fromCharCode(8203),
            primary_minor_class_code: obj?.primary_minor_class_code + String.fromCharCode(8203),
            is_active: obj?.is_active=="1"?t("Active"):t("InActive"),
            allow_tier: obj?.allow_tier=="1"?t("Yes"):t("No"),
            allow_points:obj?.allow_points=="1"?t("Yes"):t("No"),

          }
        }));

      }else{
        setExportData(res.data.map(obj => {
          return {
            ...obj,
            product_primary_class_id: obj?.product_primary_class_id + String.fromCharCode(8203),
            primary_major_class_code: obj?.primary_major_class_code + String.fromCharCode(8203),
            primary_submajor_class_code: obj?.primary_submajor_class_code + String.fromCharCode(8203),
            primary_minor_class_code: obj?.primary_minor_class_code + String.fromCharCode(8203),
            is_active: obj?.is_active=="1"?t("Active"):t("InActive"),
          }
        }));

      }
    
      dispatch({ type: "SET_LOADING", payload: false });
      setIsLoading(false);
      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
      }
      return true;
    }
  };
  const tableHeading = [
    "MPC ID",
    "MPC Description",
    "Sales Category",
    "Redemption %",
    "Org name",
    "Status",
    (state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada' ? "Allow Points" : ""),
    (state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada' ? "Allow Tier" : ""),
    "View detail",
    state?.userInfo?.auditAccess? "History":"",
  ];

  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "mpc",
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const invalidChar = ['~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';', ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'"]

  const blockInvalidChar = e => invalidChar.includes(e.key) && e.preventDefault();

  return (
    <React.Fragment>
      <GlobalCss />
      <Grid
        container
        spacing={0}
        onClick={() => {
          filterCard == true && setFilterCard(false);
        }}
      >
        {window.innerWidth < 600 && (
          <Grid xs={12}>
            <IconButton
              style={{ position: "absolute" }}
              onClick={() => {
                dispatch({ type: "SET_SIDEBAR", payload: true });
              }}
            >
              <MenuIcon />
            </IconButton>
            <span className={classes.headerText}>{t('MPC')}</span>
          </Grid>
        )}
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: 0.99 }}>
            <CssTextField
              placeholder={t('Search for MPC ID or MPC Description')}
              type={"text"}
              variant="outlined"
              onKeyDown={blockInvalidChar}
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          handleGetMpc();
                        }}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        alt=""
                        width="20px"
                        className={classes.searchInputIcon}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setOffset(1);
                if (e.target.value.length == 0) {
                  handleGetMpc();
                }
              }}
              onClick={() => {
                setOffset(offset);
              }}
            />
            <Button
              className={`${classes.filterBtn} dash-1-filter-btn`}
              onClick={() => {
                setFilterCard(!filterCard);
                if (!states.filter) {
                  setStates({
                    salesCategory: "",
                    redemptionFrom: null,
                    redemptionTo: null,
                    orgName: "",
                  });
                }
              }}
            >
              {t('Filter')}
              {response["filter"] && (
                <Badge
                  badgeContent={count == 0 ? null : response["filter"] && count}
                  color="error"
                  classes={{ badge: classes.badge }}
                  max={999999}
                  className={classes.badges}
                ></Badge>
              )}
            </Button>
          </div>
          <CSVLink
            id="csv"
            data={exportData}
            headers={state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' ? exportHeaders.map(head => {
              return { ...head, label: t(head.label) }
            }):
              exportHeaders_ca.map(head => {
                return { ...head, label: t(head.label) }
              })
            }
            filename={
              `MPC` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
          <button
            disabled={isLoading}
            className={classes.exportBtn}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
        </Grid>
      </Grid>

      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >
                  <Grid item sm={3} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>
                      {t('Sales Category')}
                    </div>

                    <Autocomplete
                      id="combo-box-demo"
                      options={salesCategory}
                      getOptionLabel={(option) => t(option.loyalty_category_code)}
                      defaultValue={selectedSales}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          value={states.salesCategory}
                        />
                      )}
                      onChange={(value, a, reason) => {
                        if (reason === "clear") {
                          setStates({ salesCategory: "" });
                          setSelectedSales({})
                          return;
                        }
                        if (a) {
                          setStates({ salesCategory: a.loyalty_category_code });
                          setSelectedSales(a);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item sm={3} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>
                      {t('Redemption %')}
                    </div>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <CssTextField
                          id="enterPassword"
                          type={"number"}
              onWheel={(e) => e.target.blur()}
                          variant="outlined"
                          placeholder={t('From')}
                          className={classes.filterCardInput}
                          autoComplete="off"
                          value={states.redemptionFrom}
                          onChange={(e) => {
                            setStates({
                              redemptionFrom: parseInt(e.target.value),
                            });
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CssTextField
                          id="enterPassword"
                          type={"number"}
              onWheel={(e) => e.target.blur()}
                          variant="outlined"
                          placeholder={t('To')}
                          autoComplete="off"
                          className={classes.filterCardInput}
                          value={states.redemptionTo}
                          onChange={(e) => {
                            setStates({
                              redemptionTo: parseInt(e.target.value),
                            });
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('Org name')}</div>
                    <Autocomplete
                      id="combo-box-demo"
                      autoSelect={true}
                      options={org}
                      getOptionLabel={(option) =>
                        option ? t(option.loyalty_organization_name) : ""
                      }
                      defaultValue={selectedOrg}
                      style={{ fontSize: "0.875rem !important" }}
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" />
                      )}
                      onChange={(value, a, reason) => {
                        if (reason === "clear") {
                          setStates({ orgName: "" });
                          setSelectedOrg({});
                          return;
                        }
                        if (a) {
                          setStates({ orgName: a.loyalty_organization_name });
                          setSelectedOrg(a);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('Status')}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.isActive}
                      onChange={(e) => {
                        setStates({ isActive: e.target.value });
                      }}
                    >
                      <MenuItem value={true}>{t('Active')}</MenuItem>
                      <MenuItem value={false}>{t('InActive')}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    sm={2}
                    xs={12}
                    className={classes.filterCardBtnGrid}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {
                            if (
                              !states.salesCategory &&
                              !states.redemptionFrom &&
                              !states.redemptionTo &&
                              !states.orgName &&
                              typeof states.isActive !== "boolean"
                            ) {
                              toast.error("Please select atleast one field.");
                              return;
                            }
                            if (!states.redemptionTo && states.redemptionFrom) {
                              toast.error("Please select To column");
                              return;
                            }
                            if (states.redemptionTo && !states.redemptionFrom) {
                              toast.error("Please select From column");
                              return;
                            }
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            setResponse({ filter: false });
                          }}
                        >
                          {t('Apply')}
                        </Button>
                      </Grid>
                      {states.filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                                salesCategory: "",
                                redemptionFrom: null,
                                redemptionTo: null,
                                orgName: "",
                                isActive: "",
                              });
                              setOffset(1);
                              setFilterCard(false);
                              setSelectedOrg({});
                              setSelectedSales({});
                              handleGetMpc();
                              setCount(0);
                              setResponse({ filter: false });
                            }}
                          >
                            {t('Reset')}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      <Loader Loading={state.loading} top={"15%"}>
        <Grid container style={{ marginTop: 22 }}>
          <Grid item xs={12} sm={12} lg={12}>
            <div className={classes.tableDiv}>
              <Table
                headings={tableHeading.map((i) => (
                  <div key={t(i)}
                    className={i === "Org name" ? classes.orgNameColumn : null}
                  >
                    {t(i)}
                  </div>
                ))}
                data={mpcData.map((p, i) => [
                  p?.product_primary_class_id,
                  p?.product_primary_class_description,
                  t(p?.loyalty_category_code),
                  p?.redemption_percentage,
                  t(p?.loyalty_organization_name),
                  [
                    p?.["is_active"] ? (
                      <span style={{ color: "green" }} key={i}>
                        {t('Active')}
                      </span>
                    ) : p?.["is_active"] != null ? (
                      <span style={{ color: "red" }} key={i}>
                        {t('InActive')}
                      </span>
                    ) : null,
                  ],
                  (state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada' &&
                    [
                      p?.["allow_points"] ? (
                        <span style={{ color: "green" }} key={i}>
                          {t('Yes')}
                        </span>
                      ) : p?.["allow_points"] != null ? (
                        <span style={{ color: "red" }} key={i}>
                          {t('No')}
                        </span>
                      ) : null,
                    ]),
                  (state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada' &&
                    [
                      p?.["allow_tier"] ? (
                        <span style={{ color: "green" }} key={i}>
                          {t('Yes')}
                        </span>
                      ) : p?.["allow_tier"] != null ? (
                        <span style={{ color: "red" }} key={i}>
                          {t('No')}
                        </span>
                      ) : null,
                    ]),
                  [
                    <RemoveRedEyeIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/mpcdetail", {
                          mpcId: p?.product_primary_class_id,
                          offset,
                        });
                      }}
                    />,
                  ],
                  state?.userInfo?.auditAccess && (
                    <HistoryIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setStates({
                          historyDialog: true,
                          historyLoader: true,
                        });
                        handleGetHistoryData(p?.product_primary_class_id);
                      }}
                    />
                  ),
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </div>
          </Grid>
        </Grid>
      </Loader>

      {/* history */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog ? true : false}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
